






































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import estimateHonorAction from '~/queries/estimateHonorAction.gql';
import { EActions, IHonorEstimate } from '~/types/honor';
import { HonorActionType } from '../../store/profile/types';
const _debounce = require('lodash.debounce');
@Component({})
export default class HonorNotice extends Vue {
  @Prop(String) readonly token!: string;
  @Prop(String) readonly game!: string;
  @Prop(String) readonly action!: EActions;
  @Prop(Number) readonly amount!: number | string;

  estimateObject: IHonorEstimate | {} = {};
  honorEnabled = process.env.enabledHonor;

  actionsMap: Record<
    string,
    { effect: string; arrow?: string; icon?: string; color?: string }
  > = {
    good: {
      effect: 'get',
      arrow: 'mdi-arrow-up-thin',
      icon: 'mdi-check-circle-outline',
      color: '#75E69D',
    },
    bad: {
      effect: 'lose',
      arrow: 'mdi-arrow-down-thin',
      icon: 'mdi-alert-outline',
      color: '#E05A30',
    },
    redeeming: {
      effect: 'redeem',
      arrow: 'mdi-shield-check-outline',
      color: 'white',
    },
    zero: {
      effect: 'pages.galaHonor.noeffect',
      icon: 'minus-circle-outline',
      color: 'white',
    },
  };

  get mapAction(): {
    effect: string;
    color?: string;
    arrow?: string;
    icon?: string;
  } {
    return this.actionsMap[
      (this.estimateObject as IHonorEstimate).honorPoints !== 0
        ? (this.estimateObject as IHonorEstimate).actionType
        : 'zero'
    ];
  }

  get formattedToken() {
    return this.token.split('[')?.[0] || '';
  }

  async fetchHonorEstimate() {
    if (!this.honorEnabled) {
      return;
    }
    try {
      const response = await this.$apollo.query({
        query: estimateHonorAction,
        variables: {
          game: this.game,
          action: this.action,
          amount: Math.ceil(Number(this.amount)),
          timestamp: new Date().toISOString(),
          coinSymbol: this.formattedToken,
        },
        fetchPolicy: 'no-cache',
      });
      this.estimateObject = response.data.estimateAction.data;
    } catch (error) {}
  }
  debouncedFetch = _debounce(this.fetchHonorEstimate, 1000);

  getEstimateText(actionType: HonorActionType) {
    switch (actionType) {
      case HonorActionType.BAD:
        return this.$t('pages.galaHonor.honorLose');
      case HonorActionType.GOOD:
        return this.$t('pages.galaHonor.honorGain');
      case HonorActionType.REDEEMING:
        return this.$t('pages.galaHonor.honorRedeem');
    }
  }
  getEstimateNextText(actionType: HonorActionType) {
    if (actionType === HonorActionType.REDEEMING) {
      return this.$t('pages.galaHonor.honorPoints');
    } else {
      return this.$t('pages.galaHonor.estimate-next');
    }
  }

  @Watch('amount')
  reFetchEstimate() {
    this.debouncedFetch();
  }

  created() {
    this.fetchHonorEstimate();
  }
}
